<template>
    <div :class="isCard ? '' : 'border'">

        <div v-if="isCard" class="theme-card" style="width: 18rem;">

            <Container orientation="vertical"
                       @drop="onRowDrop($event)"
                       drag-handle-selector=".row-tab"
                       group-name="rowContainers"
                       :get-child-payload="getRowPayload">

                <Draggable v-for="(row, index) in layout.rows" :key="index + 'Draggable'" style="overflow: visible !important;">

                    <row-container
                            :row="row"
                            :index="index"
                            :key="index + 'Row'"
                            :layout="layout"
                            :page="page"
                            :view="view"></row-container>

                </Draggable>

            </Container>

        </div>

        <Container v-else orientation="vertical"
                   @drop="onRowDrop($event)"
                   drag-handle-selector=".row-tab"
                   group-name="rowContainers"
                   :get-child-payload="getRowPayload">

            <Draggable v-for="(row, index) in layout.rows" :key="index + 'Draggable'" style="overflow: visible !important;">

                <row-container
                        :row="row"
                        :index="index"
                        :key="index + 'Row'"
                        :layout="layout"
                        :page="page"
                        :view="view"></row-container>

            </Draggable>

        </Container>
    </div>
</template>

<script>
    import RowContainer from "./RowContainer.vue";
    import PageFactory from "../../utils/PageFactory"
    import {Container, Draggable} from "vue3-smooth-dnd"
    // import Container from "../../components/draganddrop/components/Container";
    // import Draggable from "../../components/draganddrop/components/Draggable";
    import { applyDrag } from "../../utils/DragUtils"

    export default {
        name: 'LayoutRenderer',
        components: {RowContainer, Container, Draggable},
        props: ['layout', 'view', 'page'],
        data() {
            return {
                model: webase.model,
                copiedRow: null,
                copiedColumn: null,
                factory: new PageFactory(),
                pastedExecuted: false
            }
        },
        computed: {
          isCard() {
              if(this.view) {
                  return this.view.view_type === 'gallery'
              }

              return false
          }
        },
        // mounted() {
        //     window.addEventListener("keydown", this.onKeyPressed, true);
        //     window.addEventListener("keyup", this.onKeyUp, true);
        // },
        // destroyed() {
        //     window.removeEventListener("keydown", this.onKeyPressed, true);
        //     window.removeEventListener("keyup", this.onKeyUp, true);
        // },
        methods: {
            onKeyUp(event) {
                this.pastedExecuted = false
            },
            onKeyPressed(event) {
                if (event.defaultPrevented) {
                    return; // Should do nothing if the default action has been cancelled
                }

                let handled = false

                if (webase.utils.ui.copyKeysPressed(event)) {
                    this.handleCopy()
                    handled = true
                } else if (webase.utils.ui.pasteKeysPressed(event)) {
                    this.handlePaste()
                    handled = true
                }
            },

            handleCopy() {
                if (this.layout.selectedRow && this.layout.selectedColumn) {
                    let newColumn = JSON.parse(JSON.stringify(this.layout.selectedColumn))
                    newColumn.selected = false
                    this.model.clipboard = newColumn
                    return
                } else if (this.layout.selectedRow && !this.layout.selectedColumn) {
                    let newRow = JSON.parse(JSON.stringify(this.layout.selectedRow))
                    newRow.selected = false
                    this.model.clipboard = newRow
                    return
                }

                this.copiedRow = null
                this.copiedColumn = null
            },

            handlePaste() {
                if (this.pastedExecuted || !this.model.clipboard) {
                    return
                }

                // a row is on the clipboard
                if (this.layout.selectedRow && this.model.clipboard.hasOwnProperty('columns')) {
                    for (let j = 0; j < this.layout.rows.length; j++) {
                        let row = this.layout.rows[j]

                        if (row === this.layout.selectedRow) {
                            let newRow = JSON.parse(JSON.stringify(this.model.clipboard))
                            this.layout.rows.splice(j + 1, 0, newRow)
                            this.model.clipboard = null
                            break
                        }
                    }
                }
                // a column is on the clipboard
                else if (this.layout.selectedColumn && this.model.clipboard.hasOwnProperty('direction')) {
                    let newColumn = JSON.parse(JSON.stringify(this.model.clipboard))
                    this.layout.selectedRow.columns.push(newColumn)
                    this.factory.resetColumns(this.layout.selectedRow.columns)
                    this.model.clipboard = null
                } else if (this.layout.selectedColumn && this.model.clipboard.hasOwnProperty('type')) {
                    let newComponent = JSON.parse(JSON.stringify(this.model.clipboard))
                    this.layout.selectedColumn.value.push(newComponent)
                    this.model.clipboard = null
                }

                this.pastedExecuted = true
            },
            onRowDrop(dropResult) {

                if (dropResult.removedIndex === null || dropResult.addedIndex === null) {
                    return
                }

                if (dropResult.removedIndex === dropResult.addedIndex && this.layout.rows.length > 1) {

                    if(dropResult.removedIndex === 0) {
                        dropResult.addedIndex = 1
                    }

                    if(dropResult.removedIndex === this.layout.rows.length - 1) {
                        dropResult.addedIndex = dropResult.removedIndex - 1
                    }
                }

                this.layout.rows = applyDrag(this.layout.rows, dropResult)
            },
            getRowPayload(index) {
                return this.layout.rows[index]
            }
        }
    }
</script>

<style>

</style>
